import {
  LayoutDashboard,
  Calendar,
  CheckSquare,
  Images,
  MessageCircle,
  Users,
  type LucideIcon,
} from 'lucide-react';
import { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { VersionBadge } from '@/shared/components/ui';
import { buildInfo } from '@/shared/config/build';
import { RouteKey, ROUTE_PATHS } from '@/shared/constants/routes';
import { cn } from '@/shared/lib/utils';

interface NavigationItem {
  readonly name: string;
  readonly route: RouteKey;
  readonly icon: LucideIcon;
}

const navigation: readonly NavigationItem[] = [
  { name: 'Начало', route: RouteKey.DASHBOARD, icon: LayoutDashboard },
  { name: 'Календар', route: RouteKey.FAMILY_CALENDAR, icon: Calendar },
  { name: 'Задачи', route: RouteKey.TODO_LIST, icon: CheckSquare },
  { name: 'Албуми', route: RouteKey.ALBUMS, icon: Images },
  { name: 'Чат', route: RouteKey.P2P_CHAT, icon: MessageCircle },
  { name: 'Семейство', route: RouteKey.FAMILY_SETTINGS, icon: Users },
] as const;

export function Sidebar() {
  const navigationItems = useMemo(
    () =>
      navigation.map((item) => (
        <NavLink
          key={item.route}
          to={ROUTE_PATHS[item.route]}
          className={({ isActive }) =>
            cn(
              'flex min-h-[44px] items-center gap-3 rounded-md px-3 py-3 text-sm font-medium transition-colors',
              isActive
                ? 'bg-accent text-accent-foreground'
                : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground'
            )
          }
        >
          <item.icon className="size-5" aria-hidden="true" />
          {item.name}
        </NavLink>
      )),
    []
  );

  return (
    <aside
      className="hidden w-64 border-r border-border bg-card lg:block"
      aria-label="Main navigation"
    >
      <nav className="flex h-full flex-col">
        <div className="flex flex-col gap-1 p-4">{navigationItems}</div>

        {/* Footer with version */}
        <div className="p-4">
          <VersionBadge version={buildInfo.version} />
        </div>
      </nav>
    </aside>
  );
}
